/** @format */

import React, { useState, useEffect } from "react";
import { Input, Button } from "antd";
import { UserOutlined, LockOutlined } from "@ant-design/icons";
import { toast } from "react-toastify";
import { useLoginMutation } from "../redux/Auth/auth";
import { Link, useNavigate } from "react-router-dom";
import Cookies from "universal-cookie";
import { setToken } from "../redux/Auth/authSlice";

const Login = () => {
  const cookies = new Cookies();
  const navigate = useNavigate();
  const [email, setEmail] = useState();
  const [password, setPassword] = useState();
  const [fetch, { data, error, isError, isLoading, isSuccess }] =
    useLoginMutation();

  console.log(data);
  const userData = {
    userName: email,
    password: password,
  };
  useEffect(() => {
    const setToken = (token) => {
      if (token !== undefined || token === "") {
        cookies.set("token", data.token, { path: "/" });
        navigate("/");
      }
    };
    if (isSuccess === true) {
      setToken(data.token);
    }
    data && window.localStorage.setItem("role", data?.role);
    isError && toast.error("Login or password was error");
  }, [data, isError, isSuccess]);

  const handleLogin = async (e) => {
    e.preventDefault();
    await fetch(userData);
    if (isSuccess === true) {
      setToken(data.token);
      localStorage.setItem("token", data.token, { path: "/" });
    }
  };

  return (
    <div className="login">
      <div className="login__form">
        <div className="login__title">
          <h1>NEURONA</h1>
        </div>
        <form onSubmit={handleLogin}>
          <Input
            className="login__input"
            required
            placeholder="Enter login"
            prefix={<UserOutlined />}
            type="text"
            size="large"
            name="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <Input
            className="login__input"
            required
            size="large"
            placeholder="Password"
            prefix={<LockOutlined />}
            type="password"
            name="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <div className="login__button">
            {isLoading !== true ? (
              <button type="submit">Log-in</button>
            ) : (
              <Button loading type="submit">
                Log-in
              </Button>
            )}
          </div>
        </form>
      </div>
    </div>
  );
};

export default Login;
